import { RegisterForm } from '@/components/auth/register-form'
import { SmartTooltip } from '@/components/extension/smart-tooltip'
import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { formatPrice } from '@/lib/utils'
import { showPopup } from '@/providers/popup-provider'
import { InfoIcon } from 'lucide-react'
import Image from 'next/image'

interface ProductInfoCoolclubPricingProps {
  coolclubPrice: number
}
export const ProductInfoCoolclubPricing: React.FC<
  ProductInfoCoolclubPricingProps
> = ({ coolclubPrice }) => {
  const { data: user } = useUserQuery()

  if (user) return null

  return (
    <div className='mt-4 flex items-center justify-between rounded-lg bg-[#F1F3FF] px-5 py-2 text-sm'>
      <div className='flex items-center gap-2'>
        <Image
          src='/icons/icon-coolcash-box.svg'
          alt='Coolcash'
          width={16}
          height={16}
          unoptimized
          className='h-4 w-4'
        />
        <div className='flex items-center gap-1'>
          <div>Giá Coolclub:</div>
          <div className='font-medium'>{formatPrice(coolclubPrice)}</div>
          <SmartTooltip
            content='Giá chỉ dành riêng cho thành viên CoolClub'
            side='top'
            trigger='click'
          >
            <InfoIcon className='h-3.5 w-3.5' />
          </SmartTooltip>
        </div>
      </div>
      <div
        onClick={() => {
          showPopup(<RegisterForm />)
        }}
        className='ml-0 cursor-pointer text-sm font-medium text-primary underline'
      >
        Đăng ký ngay!
      </div>
    </div>
  )
}
